import { createContext, useContext } from "react";
import type { PresenceMap } from "./presence";

interface LiveViewContextValue {
  presence: PresenceMap;
  watch: (applicant: { id: number; name: string }) => void;
}

export const LiveViewContext = createContext<LiveViewContextValue | null>(null);

/**
 * Presence and "View live" for the applicants of one application. Null
 * outside a `LiveViewProvider` or when the partner doesn't have BoomView, so
 * callers render nothing.
 */
export const useLiveViewContext = () => useContext(LiveViewContext);
